<template>
  <div class="input">
    <select :value="modelValue" @input="$emit('update:modelValue', $event)" :disabled="disabled">
      <option v-for="(options, index) in options" :key="index" :value="options.value">{{ options.text }}</option>
    </select>
  </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'MiniSelect',
  components: {
    ModelSelect,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    modelValue: {
      required: true,
    },
    disabled: {
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
.input {
  padding: 0.125rem 0.25rem;
  background: transparent;
  border: 0.5px solid #D5D5D5;
  border-radius: 4px;

  font-size: .5rem;
  font-weight: 600;
  color: #2B303466;

  & select:disabled {
    cursor: not-allowed !important;
  }

  select {
    cursor: pointer;
    background: transparent;
    border: 0;
    outline: 0;
  }
}
</style>